import Employee from "../../../app/domain/Employee";

export default function adaptEmployeesForInvite({
  employees,
}: {
  employees: Employee[];
}) {
  return employees.map(
    ({ id, email, name, surname, legalId, modelId, state, grossSalary }) => ({
      id,
      email,
      name,
      surname,
      legalId,
      modelId,
      state,
      grossSalary,
    })
  );
}
